(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name drug.factory:Med
   *
   * @description
   *
   */
  angular
    .module('vcdrug')
    .factory('Med', Med);


  Med.$inject = ['restmod'];
  function Med(restmod) {
    return restmod.model('/routes/meds').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/meds/medahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }, $searchpharma: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/meds/replacement';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }
        } // Model
      }// extend
    });
  }

// klammerfriedhof
}());
